import PapercutApi, { PAPERCUT_API_URL } from '@/api/base/PapercutApi'

export default {
  sendEnquiryForm(form) {
    return PapercutApi.post(`${PAPERCUT_API_URL}/form_leads`, form)
  }
}
